export default __webpack_public_path__ + "public/assets/images/4e47e9e420403203daa52072cc60a5be.png";